import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';
import { environment } from 'src/environments/environment';
import { kbArchiveInterface } from 'src/app/util/interfaces/kbArchive';
import { map } from 'rxjs/operators';

@Injectable({
	providedIn: 'root',
})
export class KnowledgeArchiveService {
	private getKbUrl: string = environment.baseApiUrl + 'kb/{idKb}';
	private evaluateKbUrl: string = environment.baseApiUrl + 'kb/{kbId}/points/{points}';
	private newKbCommentaryUrl: string = environment.baseApiUrl + 'kb/{kbId}/comment';
	private kbReviewUrl: string = environment.baseApiUrl + 'kb/{kbId}/review';
	private kbPublishUrl: string = environment.baseApiUrl + 'kb/{kbId}/approval';

	constructor(
		private http: HttpClient,
		private AuthLoginService: AuthLoginService
	) {}

	getKb(idKb: string): Observable<kbArchiveInterface> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		const getKbUrl = this.getKbUrl.replace('{idKb}', idKb);
		return this.http.get<JSON[]>(getKbUrl, { headers: headers }).pipe(
			map((kbRes: any) => {
				kbRes = kbRes[0];
				const newKb: kbArchiveInterface = {
					id: kbRes.id,
					registered_by: kbRes.registered_by,
					driver: kbRes.driver,
					problem_manager: kbRes.problem_manager,
					version: kbRes.version,
					language: kbRes.language,
					version_date: kbRes.version_date,
					register_date: kbRes.register_date,
					summary: kbRes.summary,
					description: kbRes.description,
					points: kbRes.points,
					related_kb: [],
					tags: [],
					classification: [],
				};

				kbRes.relatedKb.forEach((relatedKb: any) => {
					const newRelatedKb: kbArchiveInterface = {
						id: relatedKb.id,
						summary: relatedKb.summary,
					};

					newKb.related_kb.push(newRelatedKb);
				});

				return newKb;
			})
		);
	}

	evaluateKb(kbId: string, points: number): Observable<JSON[]> {
		const headers = new HttpHeaders({ Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken() });
		const evaluateKbUrl = this.evaluateKbUrl.replace('{kbId}', kbId).replace('{points}', points.toString());
		return this.http.get<JSON[]>(evaluateKbUrl, { headers: headers });
	}

	newKbCommentary(kbId: string, commentary: string): Observable<JSON[]> {
		const headers = new HttpHeaders({ Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken() });
		const newKbCommentaryUrl = this.newKbCommentaryUrl.replace('{kbId}', kbId);
		const body = { comment: commentary };
		return this.http.post<JSON[]>(newKbCommentaryUrl, body, { headers: headers });
	}

	reviewKb(kbId: string, approve: boolean): Observable<JSON> {
		const headers = new HttpHeaders({ Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken() });
		const kbReviewUrl = this.kbReviewUrl.replace('{kbId}', kbId);
		const body = approve ? { status: 'Approved' } : { status: 'Rejected' };
		return this.http.put<JSON>(kbReviewUrl, body, { headers: headers });
	}

	publishKb(kbId: string, approve: boolean): Observable<JSON> {
		const headers = new HttpHeaders({ Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken() });
		const kbPublishUrl = this.kbPublishUrl.replace('{kbId}', kbId);
		const body = approve ? { status: 'Approved' } : { status: 'Rejected' };
		return this.http.put<JSON>(kbPublishUrl, body, { headers: headers });
	}
}
